const types = Object.freeze({
  News: 1,
  Event: 2,
  Workshop: 3,
  Message: 4,
  TeachingMaterial: 5,
  EducationalMaterial: 6,
  Graphic: 7,
  Metrics: 8,
  Alerts: 9,
});

export const displayNames = [
  {
    id: types.News,
    name: 'Noticias',
    color: '#F68718',
  },
  {
    id: types.Event,
    name: 'Calendario',
    color: '#7560DF',
  },
  {
    id: types.Workshop,
    name: 'Talleres',
    color: '#4599FF',
  },
  {
    id: types.Message,
    name: 'Mensajes',
    color: '#37AB4C',
  },
  {
    id: types.TeachingMaterial,
    name: 'Guias y Videos',
    color: '#FF6369',
  },
  {
    id: types.EducationalMaterial,
    name: 'Material Docente',
    color: '#06A482',
  },
  {
    id: types.Graphic,
    name: 'Gráficas',
    color: '#D69A00',
  },
  {
    id: types.Metrics,
    name: 'Métricas',
    color: '#B5C3BC',
  },
  {
    id: types.Alerts,
    name: 'Alertas',
    color: '#C53030',
  },
];
export default types;
